import { Grid, TextField } from "@material-ui/core";
import { inputColor, inputVariant } from "../../settings/inputConfig";

import MeditocModal from "../utils/MeditocModal";
import MeditocPassword from "../utils/MeditocPassword";
import { useLogin } from "../../context/LoginContext";

export default function MeditocCambiarPass() {
    const {
        formCambiarPass,
        openFormCambiarPass,
        mostrarPassword,
        handleToggleFormCambiarPass,
        handleChangeMostrarPassword,
        handleChangeFormCambiarPass,
        handleSubmitCambiarPass,
    } = useLogin();

    const { txtNuevoPasswordMeditoc, txtConfirmarPasswordMeditoc } = formCambiarPass;

    return (
        <MeditocModal
            title="Cambiar contraseña"
            size="small"
            open={openFormCambiarPass}
            setopen={handleToggleFormCambiarPass}
            okfunc={handleSubmitCambiarPass}
        >
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <TextField
                        name="txtNuevoPasswordMeditoc"
                        label={txtNuevoPasswordMeditoc.label}
                        required={txtNuevoPasswordMeditoc.required}
                        value={txtNuevoPasswordMeditoc.value}
                        error={txtNuevoPasswordMeditoc.error}
                        helperText={txtNuevoPasswordMeditoc.error && txtNuevoPasswordMeditoc.message}
                        onChange={handleChangeFormCambiarPass}
                        variant={inputVariant}
                        color={inputColor}
                        type={mostrarPassword ? "text" : "password"}
                        autoComplete="new-password"
                        autoFocus
                        fullWidth
                        InputProps={{
                            endAdornment: (
                                <MeditocPassword view={mostrarPassword} setView={handleChangeMostrarPassword} />
                            ),
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        name="txtConfirmarPasswordMeditoc"
                        label={txtConfirmarPasswordMeditoc.label}
                        required={txtConfirmarPasswordMeditoc.required}
                        value={txtConfirmarPasswordMeditoc.value}
                        error={txtConfirmarPasswordMeditoc.error}
                        helperText={txtConfirmarPasswordMeditoc.error && txtConfirmarPasswordMeditoc.message}
                        onChange={handleChangeFormCambiarPass}
                        variant={inputVariant}
                        color={inputColor}
                        type={mostrarPassword ? "text" : "password"}
                        autoComplete="new-password"
                        fullWidth
                        InputProps={{
                            endAdornment: (
                                <MeditocPassword view={mostrarPassword} setView={handleChangeMostrarPassword} />
                            ),
                        }}
                    />
                </Grid>
            </Grid>
        </MeditocModal>
    );
}
